module.exports = __webpack_public_path__ + "static/media/19ESCAP42.e4fc2f5f.jpg";